import React from 'react';

/**
 * NarrativeFlow — "Glowytics Value Story" anlatı akışı (Q&A Timeline), İngilizce.
 * Route: /hq/narrative-flow (ProtectedRoute allowEmails — sadece sahibine açık)
 * Statik sunum sayfası: toplantıda ekran paylaşımıyla gösterilir. API çağrısı yok.
 *
 * Orijinal board'un birebir İngilizce karşılığı; 4 kolon sırası korunmuştur.
 */

const COLUMNS = [
  {
    n: 1,
    title: 'Who Benefits?',
    items: [
      ['CMO / Marketing Director'],
      ['Performance Team'],
      ['E-commerce Manager'],
      ['Agency Partner'],
      ['SMB Owner (Shopify / e-commerce)'],
      ['CEO / Founder', 'speed of decision'],
      ['CFO / Finance', 'efficiency & ROI'],
      ['BI / Analytics', 'single-source-of-truth layer'],
      ['Product / CRM', 'segments & LTV'],
      ['Retail / Store Ops', 'local performance'],
      ['Creative Team', 'insight & variant testing'],
    ],
  },
  {
    n: 2,
    title: 'The Problems We Solve',
    items: [
      ['Manual reporting chaos'],
      ['Slow decisions / approval bottlenecks'],
      ['Fragmented and inconsistent data'],
      ['Inefficient optimization loop'],
      ['No creative insight'],
      ['Siloed tools (Ads / GA4 / MC / SC separate)'],
      ['Budget shifts made too late'],
      ['Attribution uncertainty'],
      ['Missing creative taxonomy / labelling'],
      ['Backfill bottlenecks'],
      ['Delayed executive updates / summaries'],
    ],
  },
  {
    n: 3,
    title: 'Core Impact',
    items: [
      ['15–25h → 1.5–3.5h per week'],
      ['Decision latency ↓ 90%'],
      ['Real-time KPIs & alerting'],
      ['AI campaign suggestions'],
      ['Automated executive updates'],
      ['Waste reduction (pausing low-ROAS)'],
      ['One-click playbooks (budget / proposal)'],
      ['Creative insights → faster variants'],
      ['Revenue / ROAS lift'],
      ['Merchandising insights (category / product / variant)'],
      ['Assortment & pricing opportunities'],
      ['Stock-aware bidding / suppression'],
      ['Cross-sell / upsell recommendations'],
      ['RFM segmentation (Recency–Frequency–Monetary)'],
      ['Lifecycle & win-back triggers'],
      ['Audience building: churn risk / high-LTV / VIP'],
    ],
  },
  {
    n: 4,
    title: 'Data Reliability & Governance',
    items: [
      ['Single schema / multi-brand'],
      ['Role-based access'],
      ['Source validation & health'],
      ['Audit & sync log'],
      ['Deterministic order (itemId, itemName)'],
      ['Backfill strategy (daily / monthly)'],
      ['Idempotent upsert'],
      ['Monitoring & alerts'],
      ['Source-of-truth contracts'],
    ],
  },
];

export default function NarrativeFlow() {
  return (
    <div className="min-h-screen bg-white p-6">
      <div className="mx-auto max-w-[1180px] overflow-hidden rounded-[10px] border border-slate-300 bg-white">

        <div className="bg-[#0B0C0E] px-[18px] py-3.5 text-[13.5px] font-semibold tracking-tight text-white">
          Narrative Flow (Q&amp;A Timeline)
        </div>

        <div className="flex flex-col gap-5 px-[22px] pb-9 pt-[26px] lg:flex-row lg:gap-[22px]">

          <div className="h-fit w-[84px] flex-none rounded-md bg-[#F03030] px-2.5 py-[11px] text-[12.5px] font-bold leading-tight text-white">
            Glowytics Value Story
          </div>

          <div className="grid flex-1 gap-[22px] sm:grid-cols-2 lg:grid-cols-4">
            {COLUMNS.map((col) => (
              <div key={col.n} className="flex flex-col">
                <div className="inline-flex items-center gap-2.5 self-start rounded-lg border border-slate-200 bg-white py-2 pl-2 pr-3.5 shadow-sm">
                  <span className="grid h-[22px] w-[22px] flex-none place-items-center rounded-full bg-[#101114] text-[11.5px] font-bold text-white">
                    {col.n}
                  </span>
                  <span className="text-[14.5px] font-semibold tracking-tight text-[#101114]">
                    {col.title}
                  </span>
                </div>

                {/* header altındaki kısa bağlayıcı çizgi */}
                <div className="ml-[30px] mb-1.5 h-[22px] w-px bg-slate-300" />

                <div className="flex flex-col gap-2">
                  {col.items.map(([label, note]) => (
                    <div
                      key={label}
                      className="rounded-md border border-slate-200 bg-slate-100 px-3 py-2.5 text-[12.5px] leading-snug text-slate-700"
                    >
                      {label}
                      {note && <span className="text-slate-400"> ({note})</span>}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}
